import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { TabBar as AntdTabBar } from 'antd-mobile'
import { Footer } from '../Layout'
import { PATH } from '../../constants/PATH'
import { withTranslation } from 'react-i18next'

const { Item } = AntdTabBar

let tabBarColor = ''
switch (process.env['REACT_APP_CHANNEL']) {
  case 'qxtj':
  case 'qxyg':
  case 'qxdg':
  case 'tjyg':
  case 'haiou':
    tabBarColor = '#1478ff'
    break
  // case 'youpin':
  // case 'ytyg':
  // case 'dyyg':
  // case 'xbyg':
  // case 'xibei':
  // case 'xiniu':
  // case 'tradeasy':
  //   break
  default:
    tabBarColor = '#E32527'
}

const defaultTabs = [{
  title: '首页',
  route: PATH.MALL_HOME,
  key: 'home',
  icon: 'icon-shop',
  t_key: 'tab_1'
}, {
//   title: '分类',
//   route: PATH.MALL_PRODUCT_LIST,
//   icon: 'list'
// }, {
  title: '购物车',
  route: PATH.MALL_SHOPPING_CART,
  key: 'cart',
  icon: 'icon-cart',
  t_key: 'tab_2'
}, {
  title: '订单',
  route: PATH.MALL_ORDER_LIST,
  key: 'order',
  icon: 'icon-form',
  t_key: 'tab_3'
}]

@withTranslation()
@withRouter
class TabBar extends React.PureComponent {

  static propTypes = {
    selectedKey: PropTypes.string,
    tabs: PropTypes.array,
  }

  static defaultProps = {
    tabs: defaultTabs
  }

  render () {
    const { selectedKey, tabs, t } = this.props
    return <Footer>
      <AntdTabBar
        className='w-full'
        tintColor={tabBarColor}
        activeKey={selectedKey}
        onChange={this.onItemPress}
      >
        {
          tabs.map(item => {
            return <Item
              key={item.key}
              title={t(`mall.${item.t_key}`)}
              icon={<i className={`icon-font ${item.icon}`}/>}
              selectedIcon={<i className={`icon-font ${item.icon}`}/>}
            />
          })
        }
      </AntdTabBar>
    </Footer>
  }

  onItemPress = (key) => {
    const { history, tabs, selectedKey } = this.props
    if (selectedKey !== key) {
      const item = tabs.find(item => item.key === key)
      history.push(item.route)
    }
  }
}

export { TabBar }
